<template>
  <!-- 浮动按钮与弹窗助手已废弃，AI 对话由各页面内嵌的 ai-panel 承担 -->
  <div class="ai-assistant"></div>
</template>

<script setup lang="ts">
// 已废弃的浮动助手组件，保留空实现以避免引用错误
</script>

<style scoped>
.ai-assistant {
  display: none;
}
</style>
